import { Link } from "react-router-dom";

/** Marketing header brand — transparent banner wordmark (#619). */
export function SiteLogo() {
  return (
    <Link to="/" className="site-logo" aria-label="Lumora home">
      <img
        className="site-logo-banner"
        src="/brand/lumora-banner.png"
        alt="Lumora"
        width={175}
        height={32}
        decoding="async"
      />
    </Link>
  );
}
